import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => {
    history.pushState(null, null, document.URL)
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('./components/login.vue')
    },
    {
      path:'/layout',
      name: 'Layout',
      component: () => import('./components/layout.vue')
    },
    {
      path: '/main',
      name: 'Main',
      component: () => import('./components/main.vue')
    },
    {
      path: '/deviceLogin', //设备登录
      name: 'DeviceLogin',
      component: () => import('./components/deviceLogin.vue'),
    },
    {
      path: '/deviceManage', //设备管理
      name: 'DeviceManage',
      component: () => import('./components/device.vue')
    }
  ]
})
